import { useQuery } from '@tanstack/react-query';
import { fetchOrgAssignments, type OrgAssignment } from '@/api/orgAdmin';
import { ACCOUNT_COUNT_MAX_PAGES } from './helpers';

/**
 * EAA-1817: walks every page of the acting org's active Assignments so
 * `accountCountsByRoleKey` (helpers.ts) has real per-role_key totals for the
 * editor panel's "N tài khoản" lines and the remove-chip confirm. Capped at
 * `ACCOUNT_COUNT_MAX_PAGES` — see helpers.ts for why.
 */
export function useAccountAssignments(
    apiBase: string,
    accessToken: string | null,
    orgId: string | null,
    enabled: boolean
) {
    return useQuery({
        queryKey: ['role-map-org-assignments-all', accessToken, orgId],
        queryFn: async (): Promise<OrgAssignment[]> => {
            const all: OrgAssignment[] = [];
            let page = 1;
            for (;;) {
                const res = await fetchOrgAssignments(apiBase, accessToken as string, orgId as string, {
                    page,
                    page_size: 100,
                    is_active: true,
                });
                all.push(...res.results);
                if (page >= res.total_pages || page >= ACCOUNT_COUNT_MAX_PAGES) break;
                page += 1;
            }
            return all;
        },
        enabled: enabled && Boolean(orgId),
        retry: false,
    });
}
